import { render, staticRenderFns } from "./BuyerEditSoftphoneCampaign.vue?vue&type=template&id=457750a2&scoped=true"
import script from "./BuyerEditSoftphoneCampaign.vue?vue&type=script&lang=js"
export * from "./BuyerEditSoftphoneCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457750a2",
  null
  
)

export default component.exports